var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignalGood(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 384C18.75 384 8 394.75 8 408V488C8 501.25 18.75 512 32 512S56 501.25 56 488V408C56 394.75 45.25 384 32 384ZM160 288C146.75 288 136 298.75 136 312V488C136 501.25 146.75 512 160 512S184 501.25 184 488V312C184 298.75 173.25 288 160 288ZM288 192C274.75 192 264 202.75 264 216V488C264 501.25 274.75 512 288 512S312 501.25 312 488V216C312 202.75 301.25 192 288 192Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalGood);
export default __webpack_public_path__ + "static/media/signal-good.a8f206d7e2a1d443817f386f0a32823a.svg";
export { ForwardRef as ReactComponent };